import { useFormContext } from 'react-hook-form';
import { useEffect } from 'react';
import { FormFieldV2 } from '../form-field-v2';
import { Label } from '@/components/ui/label';
import { FormMode } from '@/types/form';
import { useDonViCoSo } from '@/hooks';
import { cn } from '@/lib/utils';

interface UnitDropdownV2Props {
  formMode?: FormMode;
  label?: string;
  className?: string;
  labelClassName?: string;
  selectClassName?: string;
  name?: string;
}

export const UnitDropdownV2 = ({
  formMode = 'add',
  label = 'Đơn vị',
  className,
  labelClassName = 'w-36 min-w-36',
  selectClassName = 'w-[240px]',
  name = 'unit_id'
}: UnitDropdownV2Props) => {
  const { donViCoSos } = useDonViCoSo();
  const { setValue, watch } = useFormContext();
  const currentValue = watch(name);

  const options = donViCoSos.map(donViCoSo => ({
    value: donViCoSo.uuid,
    label: donViCoSo.ten_unit
  }));

  useEffect(() => {
    if (!currentValue && donViCoSos[0]?.uuid) {
      setValue(name, donViCoSos[0].uuid);
    }
  }, [currentValue, donViCoSos, name, setValue]);

  return (
    <div className={cn('flex items-center', className)}>
      <Label className={labelClassName}>{label}</Label>
      <div className={selectClassName}>
        <FormFieldV2 type='select' name={name} options={options} disabled={formMode === 'view'} />
      </div>
    </div>
  );
};
